export default __webpack_public_path__ + "static/media/Theme21.1e3e552a.jpg";